import { render, staticRenderFns } from "./admin-contract-statistics.vue?vue&type=template&id=1f524a9d&scoped=true"
import script from "./admin-contract-statistics.vue?vue&type=script&lang=js"
export * from "./admin-contract-statistics.vue?vue&type=script&lang=js"
import style0 from "./admin-contract-statistics.vue?vue&type=style&index=0&id=1f524a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f524a9d",
  null
  
)

export default component.exports